module.exports = __webpack_public_path__ + "pc/img/acc-on.171f4e4a.svg";